import { render, staticRenderFns } from "./RegisterContainer.vue?vue&type=template&id=34f19683&"
import script from "./RegisterContainer.vue?vue&type=script&lang=ts&"
export * from "./RegisterContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports